import { SettingsSubModule } from '../utils/settings-sub-module';
import { SettingValue } from '../utils/setting-value';
import { SettingsModule } from '../utils/settings-module';

export namespace ConfidentialityAgreementFields {
  export enum CommonField {
    Enabled = 'CA.Enabled',
    ProposeEveryVisit = 'CA.ProposeEveryVisit',
    Default = 'CA.Default',
    IgnoredUsers = 'Ignored.Users',
    IgnoredDomains = 'Ignored.Domains',
  }
}

class CommonConfig extends SettingsSubModule {
  @SettingsSubModule.value(ConfidentialityAgreementFields.CommonField.Enabled, false) enabled: SettingValue<boolean>;
  @SettingsSubModule.value(ConfidentialityAgreementFields.CommonField.ProposeEveryVisit, false)
  proposeEveryVisit: SettingValue<boolean>;
  @SettingsSubModule.value(ConfidentialityAgreementFields.CommonField.Default, '0') default: SettingValue<string>;
  @SettingsSubModule.value(ConfidentialityAgreementFields.CommonField.IgnoredUsers, '')
  ignoredUsers: SettingValue<string>;
  @SettingsSubModule.value(ConfidentialityAgreementFields.CommonField.IgnoredDomains, '')
  ignoredDomains: SettingValue<string>;
}

export class ConfidentialityAgreementModule extends SettingsModule {
  @SettingsModule.value(CommonConfig) common: CommonConfig;
}
